"use strict";
require('./CompanyTimestampsService.js');

function dateIsEqual(a, b) {
  if(a instanceof Date && b instanceof Date) {
    return a.getTime() === b.getTime();
  }

  return false;
}

CompanyTimestampDetailCtrl.$inject = [
  '$scope',
  '$stateParams',
  '$state',
  '$filter',
  'info',
  'CompanyTimestampsService',
  'CompanyUserService',
  'CompanyCustomersService',
  'CompanyCustomerService',
  'CompanyCustomerServiceService',
  '$translate',
  'timestamps',
  'growl'];

function CompanyTimestampDetailCtrl(
  $scope,
  $stateParams,
  $state,
  $filter,
  info,
  CompanyTimestampsService,
  CompanyUserService,
  CompanyCustomersService,
  CompanyCustomerService,
  CompanyCustomerServiceService,
  $translate,
  timestamps,
  growl) {
  $scope.timestamps = timestamps;
  $scope.users = [];
  $scope.info = info;

  $scope.filterCustomer = '';
  $scope.startAt = '';
  $scope.endedAt = '';
  $scope.reportTime = {
    objectType: 'CUSTOMER_SERVICE',
    status: 'APPROVED',
    isWorkTime: false,
    isTimeBack: false,
    endedByClock: false
  };

  $scope.reportPage = 0;
  $scope.filterReport = {
    companyId: $stateParams.companyId,
    userId: null,
    isWorkTime: false,
    endedByClock: false,
    startTime: null,
    endTime: null,
    limit: 21,
    offset: 0
  };
  $scope.filterTime = {
    startTime: null,
    endTime: null
  };
  
  $scope.tabs = [];

  if($scope.currentUserPermissions.TimestampHistory){
    $scope.tabs.push({
      'title': 'timestamp.active-timestamp',
      'template': 'partials/company/timestamps/active-timestamp.html'
    });
  }
  if($scope.currentUserPermissions.ManualReport){
    $scope.tabs.push({
      'title': 'timestamp.manual-report',
      'template': 'partials/company/timestamps/manual-report.html'
    });
  }
  $scope.tabs.push({
    'title': 'form.report',
    'template': 'partials/company/timestamps/report.html'
  });
  $scope.tabs.push({
    'title': 'settings.settings',
    'template': 'partials/company/timestamps/settings.html'
  });

  $scope.activeTab = 0;
  if($stateParams.manual){
    $scope.activeTab = 1;
  }

  $scope.endTimestamp = function(timestamp){
    CompanyTimestampsService.update({
      companyId: $stateParams.companyId,
      timestampId: timestamp.id
    }, {}, function(){
      growl.addSuccessMessage($translate.instant('timestamp.ended-timestamp-success'));
      $scope.timestamps.splice($scope.timestamps.indexOf(timestamp), 1);
    }, function(){
      growl.addSuccessMessage($translate.instant('timestamp.ended-timestamp-failure'));
    });
  };

  $scope.checkTypeTimeTrack = function(track){
    if(!$scope.info.extra.timestamp){
      $scope.info.extra.timestamp = {typeTimeTrack: []};
    }else{
      if(!$scope.info.extra.timestamp.typeTimeTrack){
        $scope.info.extra.timestamp.typeTimeTrack = [];
      }
    }
    var index = $scope.info.extra.timestamp.typeTimeTrack.indexOf(track);
    if(index > -1){
      $scope.info.extra.timestamp.typeTimeTrack.splice(index, 1);
    }else{
      $scope.info.extra.timestamp.typeTimeTrack.push(track);
    }
  };

  $scope.searchUsers = function(filter) {
    CompanyUserService.query({companyId: $scope.companyId, q: filter, limit: 10}).$promise.then(function(users) {
      $scope.users = users;
    });
  };

  $scope.searchCustomers = function(filter) {
    CompanyCustomersService.query({companyId: $scope.companyId, q: filter, limit: 10}).$promise.then(function(customers) {
      $scope.customers = customers;
    });
  };

  $scope.searchServices = function(customer) {
    CompanyCustomerService.query({companyId: $scope.companyId, customerId: customer.id, limit: 50}).$promise.then(function(services) {
      $scope.services = services;
      $scope.reportTime.object = services[0];
    });
  };

  $scope.setCustomerServiceTimestamp = function(workdate, hourStartAt, minuteStartAt, hourEndedAt, minuteEndedAt){
    var workdateR = new Date(workdate);
    $scope.reportTime.startAt = new Date(workdateR.getFullYear() + '-' + (workdateR.getMonth()+1) + '-' + workdateR.getDate() + ' ' + hourStartAt + ':' + minuteStartAt + ':00');
    $scope.reportTime.endedAt = new Date(workdateR.getFullYear() + '-' + (workdateR.getMonth()+1) + '-' + workdateR.getDate() + ' ' + hourEndedAt + ':' + minuteEndedAt + ':00');
    if($scope.reportTime.isWorkTime){
      $scope.reportTime.object = null;
    }
    CompanyTimestampsService.save({
      companyId: $stateParams.companyId
    }, $scope.reportTime, function(){
      growl.addSuccessMessage($translate.instant('timestamp.started-timestamp-success'));
      $scope.reportTime = {
        objectType: 'CUSTOMER_SERVICE',
        status: 'APPROVED',
        isWorkTime: false,
        isTimeBack: false,
        endedByClock: false
      };
      $scope.services = [];
    }, function(err){
      if(err.status === 400){
        growl.addErrorMessage(err.data);
      }
      if(err.status === 403){
        growl.addErrorMessage(err.data.error.message);
      }
    });
  };

  $scope.$watch("[filterTime.startTime, filterTime.endTime]", function(newValue, oldValue) {
    if($scope.filterTime.startTime !== null){
      $scope.filterTime.startTime = new Date($scope.filterTime.startTime);
    }
    if($scope.filterTime.endTime !== null){
      $scope.filterTime.endTime = new Date($scope.filterTime.endTime);
    }
    if(newValue[0] && oldValue[0] && !dateIsEqual(newValue[0], oldValue[0])) {
      if($scope.filterTime.endTime !== null && $scope.filterTime.startTime >= $scope.filterTime.endTime){
        $scope.filterTime.endTime = $scope.filterTime.startTime;
      }
    }
    if(newValue[1] && oldValue[1] && !dateIsEqual(newValue[1], oldValue[1])){
      if($scope.filterTime.startTime !== null && $scope.filterTime.startTime >= $scope.filterTime.endTime){
        $scope.filterTime.startTime = $scope.filterTime.endTime;
      }
    }
  }, true);

  $scope.showReport = function(reportPage){
    if($scope.filterTime.startTime !== null){
      $scope.filterReport.startTime = $filter('date')($scope.filterTime.startTime, "yyyy-MM-dd");
    }
    if($scope.filterTime.endTime !== null){
      $scope.filterReport.endTime = $filter('date')($scope.filterTime.endTime, "yyyy-MM-dd");
    }
    $scope.reportPage = reportPage;
    $scope.filterReport.offset = reportPage * 20;
    if($scope.filterReport.isWorkTime){ 
      $scope.filterReport.objectId = null;
      CompanyTimestampsService.queryWorkTime($scope.filterReport).$promise.then(function(reportTimes) {
        $scope.reportTimes = reportTimes;
        if(reportTimes.length > 20){
          $scope.reportMore = true;
          $scope.reportTimes.pop();
        }else{
          $scope.reportMore = false;
        }
      });
    }else{
      CompanyTimestampsService.query($scope.filterReport).$promise.then(function(reportTimes) {
        $scope.reportTimes = reportTimes;
        if(reportTimes.length > 20){
          $scope.reportMore = true;
          $scope.reportTimes.pop();
        }else{
          $scope.reportMore = false;
        }
      });
    }
  };

  $scope.clearAll = function(){
    $scope.filterReport = {
      companyId: $stateParams.companyId,
      userId: null,
      isWorkTime: false,
      endedByClock: false,
      startTime: null,
      endTime: null,
      limit: 21,
      offset: 0
    };
    $scope.filterTime = {
      startTime: null,
      endTime: null
    };
    $scope.customers = [];
    $scope.services = [];
    $scope.reportTimes = [];
    $scope.reportPage = 0;
    $scope.reportMore = false;
    angular.element('.filterTime').val('');
  };
}

CompanyTimestampDetailCtrl.resolve = {
  timestamps: ['$stateParams', 'CompanyTimestampsService', function($stateParams, CompanyTimestampsService) {
    return CompanyTimestampsService.query({
      companyId: $stateParams.companyId,
      status: 'IN_PROGRESS',
      limit: 21,
      offset: 0}).$promise;
  }]
};

module.exports  = CompanyTimestampDetailCtrl;

angular.module("dokiv")
  .controller("CompanyTimestampDetailCtrl", CompanyTimestampDetailCtrl);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/timestamps/CompanyTimestampDetailCtrl.js
// module id = 423
// module chunks = 0